import errorCodes from '@player/src/errors/errorcodes.js';
let defaultData={
    reason:"player error",
    code:-1 
}
function getErrorDetails(code){
    let errorData=errorCodes[code];
    return errorData??defaultData;
}

export {getErrorDetails};